import styled from 'styled-components';

import { PostReportDataType } from '@/hooks/usePostReportModal';
import { BoardComment } from '@/types/community';

import PostCommentItem from './PostCommentItem';

interface Props {
  comments: Array<BoardComment>;
  onShowReportModal: (e: React.MouseEvent, data: PostReportDataType) => void;
  setLikeCommentStatus: (
    e: React.MouseEvent,
    boardCommentPid: string,
    isLike: boolean,
  ) => void;
  isAdmin: boolean;
}

const PostMultipleComment = ({
  comments,
  onShowReportModal,
  setLikeCommentStatus,
  isAdmin,
}: Props) => {
  return (
    <>
      {comments.map((comment, key) => {
        const isReplyComment =
          comment.boardCommentPid !== comment.parentBoardCommentPid;
        return (
          <ul key={`comment_${comment.parentBoardCommentPid}`}>
            <Divider isVisible={!isReplyComment && !!key} />
            <PostCommentItem
              comment={comment}
              isReplyComment={isReplyComment}
              setLikeCommentStatus={setLikeCommentStatus}
              onShowReportModal={onShowReportModal}
              isAdmin={isAdmin}
            />
          </ul>
        );
      })}
    </>
  );
};

export default PostMultipleComment;

const Divider = styled.div<{ isVisible: boolean }>`
  height: 1px;
  margin: 8px 24px;

  ${({ theme, isVisible }) => `
    background: ${theme.color.gray50};
    display: ${isVisible ? 'block' : 'none'};
  `};
`;
